/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getMetricGroupOverrides';
import type { GetMetricGroupQueryParams } from '../../operation-overrides/getMetricGroupOverrides';

export type GetMetricGroupPathParams = NonNullable<operations['getMetricGroup']['parameters']['path']>;
export type { GetMetricGroupQueryParams };

export interface Input extends GetMetricGroupPathParams {
  apiVersion?: string;
  query?: GetMetricGroupQueryParams;
}

export async function getMetricGroup(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/metric-groups/{metricGroupKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
